<template>
  <UiBox class="ui-box-apply" bgType="light" layout="single">
    <template v-slot:nav-left>
      <UiTab class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">队员信息</span>
          <span class="label-text">队员信息</span>
        </div>
      </UiTab>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div v-for="(item, i) in player" :key="i">
              <div class="row">
                <input
                  type="text"
                  v-model="item.nick"
                  :placeholder="`${item.label} - 昵称(填正式服ID显示)`"
                  disabled
                />
                <input
                  v-if="item.position === 'leader'"
                  type="text"
                  v-model="item.contact"
                  :placeholder="`${item.label} - 联系方式,需标明QQ微信`"
                >
              </div>
              <div class="row">
                <input
                  type="text"
                  v-model="item.uid"
                  :placeholder="`${item.label} - 正式服ID`"
                  :disabled="item.position === 'leader'"
                  :class="{ err: !item.valid }"
                  @blur="reqNick(item)"
                />
                <input
                  type="text"
                  v-model="item.address"
                  :placeholder="`${item.label} - 现居地(精确到市)`"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <UiButton class="btn" colorType="gold" @click="next">
            <div class="label-box">
              <span class="label-shadow">下一项</span>
              <span class="label-text">下一项</span>
            </div>
          </UiButton>
        </div>
      </div>
    </template>
  </UiBox>
</template>

<script setup>
import { ref, computed, watch, inject } from 'vue'
import { usePrompt } from '@/composables/usePrompt'
import { useAppStore } from '@/store'
import lg from '@/utils/lg'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';
import * as api from '@/service/index';

const apply_info = inject('apply_info')
const handleStepSubmit = inject('handleStepSubmit')
const handleStep = inject('handleStep')
const { showPrompt: promptMsg } = usePrompt()
const mockApply = inject('mockApply', null)

const emit = defineEmits(['confirm'])

const appStore = useAppStore()

const player = ref([
  {
    position: 'leader',
    label: '队长',
    uid: '',
    nick: '',
    valid: true,
    address: '',
    contact: ''
  },
  {
    position: 'player',
    label: '队员1',
    uid: '',
    nick: '',
    valid: true,
    address: ''
  },
  {
    position: 'player',
    label: '队员2',
    uid: '',
    nick: '',
    valid: true,
    address: ''
  },
  {
    position: 'player',
    label: '队员3',
    uid: '',
    nick: '',
    valid: true,
    address: ''
  },
  {
    position: 'substitute',
    label: '替补',
    uid: '',
    nick: '',
    valid: true,
    address: ''
  }
])
const mapLabel = {
  uid: 'ID',
  nick: 'ID不存在',
  address: '现居地',
  contact: '联系方式'
}
const loading = ref(false)

const token = computed(() => appStore.token)
const Info = computed(() => apply_info())

watch(
  Info,
  (val, oldVal) => {
    if(val !== oldVal && val.uid) {
      let leader = player.value.find(item => item.position === 'leader');
      leader.uid = val.uid;
      reqNick(leader);
    }
  },
  { immediate: true, deep: true }
)

function validInfo() {
  let valid = true;

  // 验证是否填写信息
  for(let item of player.value) {
    if(
      (item.position !== 'substitute' && (!item.uid || !item.address || !item.nick || (item.position === 'leader' && !item.contact))) ||
      (item.position === 'substitute' && (item.uid || item.address || item.nick))
    ) {
      if(item.uid && !item.nick) {
        valid = false;
        promptMsg(`${item.label} - ${mapLabel['nick']}`);
        break;
      }else if(!item.uid) {
        valid = false;
        promptMsg(`请填写: ${item.label} - ${mapLabel['uid']}`);
        break;
      }else if(item.position === 'leader' && !item.contact) {
        valid = false;
        promptMsg(`请填写: ${item.label} - ${mapLabel['contact']}`);
        break;
      }else if(!item.address) {
        valid = false;
        promptMsg(`请填写: ${item.label} - ${mapLabel['address']}`);
        break;
      }
    }
  }

  // 验证至少包含3名队员
  if(valid) {
    let p = player.value.filter(item => item.position !== 'substitute' && item.uid);
    if(p.length !== 4) {
      valid = false;
      promptMsg('至少包含3名队员');
    }
  }

  // 验证是否重复填写队员
  if(valid) {
    let tempArr = player.value.map(item => item.uid);
    let is_report = player.value.some((item, index) => index !== tempArr.indexOf(item.uid));
    if(is_report) {
      valid = false;
      promptMsg('队员信息重复');
    }
  }

  return valid;
}

function next() {
  if (mockApply?.bypassValidate) {
    handleStepSubmit(2, player.value);
    handleStep(3)
    return
  }
  let valid = validInfo();
  if(valid) {
    handleStepSubmit(2, player.value);
    handleStep(3)
  }
}

function reqNick(item) {
  if(!item.uid) {
    item.nick = '';
    return;
  }

  let subNick = sessionStorage.getItem(item.uid);
  if(subNick) {
    item.nick = JSON.parse(subNick);
    item.valid = true;
  }else {
    // 当找不到缓存时, 请求验证
    if(loading.value) return;
    if(!token.value) return;
    loading.value = true;
    api.reqNick({
      token: token.value,
      uid: item.uid
    }).then(r => {
      if(r.status === 200) {
        item.nick = lg(r.data, 'nick', '');
        if(item.nick) {
          item.valid = true

          // 为了减少非必要uid验证, 采用sessionStorage缓存
          sessionStorage.setItem(item.uid, JSON.stringify(item.nick));
        }else {
          promptMsg('未找到该用户信息')
          item.valid = false
        }
      }else {
        promptMsg(r.data)
        item.nick = ''
        item.valid = false
      }
      loading.value = false;
    })
  }
}

function handleExit() {
  emit('confirm')
}
</script>

<style lang="scss" scoped>
@import './_form';

// step2 独有
.title i {
  @include icon_status('team_2');
}

.inner-container {
  position: relative;
  .scroll-box {
    .info-box {
      width: get_vw(824);
      margin: 0 auto;
      .row {
        width: 100%;
        height: get_vw(68);
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: get_vw(30);
        input {
          width: get_vw(400);
          height: 100%;
          border: get_vw(2) solid #ccc;
          background-color: #fff;
          // 字号/边框/圆角全部跟随 vw, 与 input 主体同步缩放, 避免宽高比偏离时比例失调
          font-size: get_vw(20);
          color: #333;
          box-sizing: border-box;
          padding-left: get_vw(35);
          outline: none;
          &:disabled {
            background-color: #eee;
          }
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #cccccc;
          opacity: 1; /* Firefox */
        }
        :input-placeholder { /* Internet Explorer 10-11 */
          color: #cccccc;
        }
        ::input-placeholder { /* Microsoft Edge */
          color: #cccccc;
        }

        @keyframes shake {
          0% {
            transform: translate3d(0, 0, 0);
          }
          25% {
            transform: translate3d(-0.5vw, 0, 0);
          }
          75% {
            transform: translate3d(0.5vw, 0, 0);
          }
          100% {
            transform: translate3d(0, 0, 0);
          }
        }
        .err {
          border: get_vh(2) solid #EA3323;
          animation: shake 150ms ease-in-out;
        }
      }
    }
  }
  .bottom-box {
    justify-content: flex-end;
    .btn {
      margin-right: get_vh(42);
    }
  }
}
</style>
